import { render } from "./IPLine.vue?vue&type=template&id=4c23b9a8&scoped=true"
import script from "./IPLine.vue?vue&type=script&lang=js"
export * from "./IPLine.vue?vue&type=script&lang=js"

import "./IPLine.vue?vue&type=style&index=0&id=4c23b9a8&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c23b9a8"]])

export default __exports__